<template>
  <div>
    <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
      <div class="single container-max page-content mb-4">
        <div class="row position-relative">
          <div class="col-12 col-md-6 mt-md-5 px-0 px-md-3">
            <slot name="image-carousel"></slot>

            <div class="fs-saving bg-danger text-white border-radius p-2 d-inline position-absolute" v-if="savingMoneyPercent > 0">
              <span>-{{ Math.floor(savingMoneyPercent) }}%</span>
            </div>

            <template v-if="currentVariation.variationProperties && currentVariation.variationProperties.length > 0">
              <template v-for="(variationPropertyGroups, index) in currentVariation.variationProperties" v-if="variationPropertyGroups.id === 35">
                <button
                  type="button"
                  class="btn btn-primary fs-video-btn border-radius font-weight-bold d-flex align-items-center"
                  data-toggle="modal"
                  data-target="#product-video"
                  v-html="$translate('ohrensessel::SingleItem.ModalButtonText')"
                ></button>

                <!-- Modal -->
                <div class="modal fade" id="product-video" tabindex="-1" role="dialog" aria-labelledby="product-video" aria-hidden="true">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="product-video-label" v-html="$translate('ohrensessel::SingleItem.ModalHeadline')"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div class="container-max px-0">
                          <div class="row">
                            <template v-for="variationProperty in variationPropertyGroups.properties">
                              <div class="col-12 col-md-6 mb-3">
                                <video controls :poster="$translate('ohrensessel::SingleItem.ModalDefaulImage')">
                                  <source :src="variationProperty.values.value" type="video/mp4" />
                                </video>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" v-html="$translate('ohrensessel::SingleItem.ModalClose')"></button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </div>

          <div class="col-12 col-md-6 mt-md-5 px-0 px-md-3">
            <div>
              <!-- START SINGLEITEM_DETAILS <div v-stick-in-parent> -->

              <h1 class="h4 title font-weight-bold mt-3 mt-lg-1 mb-3 mb-lg-4 px-3 px-md-0 head-font" data-testing="item-name">
                <span>{{ currentVariation | itemName }}</span>
              </h1>

              <div class="buy-box pt-4 p-3 border-radius mb-4">
                <div class="single-usp d-flex w-100 justify-content-between align-items-center">
                  <ul class="list-unstyled m-0">
                    <li><span class="font-weight-bold text-center" v-html="$translate('ohrensessel::SingleItem.Usp1')"></span></li>
                    <li><span class="font-weight-bold text-center" v-html="$translate('ohrensessel::SingleItem.Usp2')"></span></li>
                    <li><span class="font-weight-bold text-center" v-html="$translate('ohrensessel::SingleItem.Usp3')"></span></li>
                    <li v-if="$translate('ohrensessel::SingleItem.Usp4')">
                      <span class="font-weight-bold text-center" v-html="$translate('ohrensessel::SingleItem.Usp4')"></span>
                    </li>
                    <li v-if="$translate('ohrensessel::SingleItem.Usp5')">
                      <span class="font-weight-bold text-center" v-html="$translate('ohrensessel::SingleItem.Usp5')"></span>
                    </li>
                  </ul>
                </div>

                <!-- Variation -->
                <div class="mt-3" v-if="attributes.length || Object.keys(units).length">
                  <variation-select></variation-select>
                </div>
                <!-- /Variation -->

                <!-- Item Bundle -->
                <item-bundle
                  v-if="currentVariation.variation.bundleType === 'bundle'"
                  :bundle-type="currentVariation.variation.bundleType"
                  :bundle-components="currentVariation.bundleComponents"
                ></item-bundle>
                <!-- /Item Bundle -->

                <slot name="before-price"></slot>

                <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                  <order-property-list></order-property-list>
                </div>

                <graduated-prices></graduated-prices>

                <div class="d-flex w-100 justify-content-between align-items-center">
                  <div class="fs-availability d-flex flex-wrap align-items-center">
                    <span
                      class="mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-1"
                      v-if="currentVariation.variation.availability.id == 1"
                      v-html="$translate('ohrensessel::ItemAvailability.Availability1')"
                    ></span>
                    <span
                      class="mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-2"
                      v-if="currentVariation.variation.availability.id == 2"
                      v-html="$translate('ohrensessel::ItemAvailability.Availability2')"
                    ></span>
                    <span
                      class="mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-3"
                      v-if="currentVariation.variation.availability.id == 3"
                      v-html="$translate('ohrensessel::ItemAvailability.Availability3')"
                    ></span>
                    <span
                      class="mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-4"
                      v-if="currentVariation.variation.availability.id == 4"
                      v-html="$translate('ohrensessel::ItemAvailability.Availability4')"
                    ></span>
                    <span
                      class="mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-5"
                      v-if="currentVariation.variation.availability.id == 5"
                      v-html="$translate('ohrensessel::ItemAvailability.Availability5')"
                    ></span>
                    <span
                      class="mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-6"
                      v-if="currentVariation.variation.availability.id == 6"
                      v-html="$translate('ohrensessel::ItemAvailability.Availability6')"
                    ></span>
                    <span
                      class="mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-7"
                      v-if="currentVariation.variation.availability.id == 7"
                      v-html="$translate('ohrensessel::ItemAvailability.Availability7')"
                    ></span>
                    <span
                      class="mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-8"
                      v-if="currentVariation.variation.availability.id == 8"
                      v-html="$translate('ohrensessel::ItemAvailability.Availability8')"
                    ></span>
                    <span
                      class="mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-9 text-dark"
                      v-if="currentVariation.variation.availability.id == 9"
                      v-html="$translate('ohrensessel::ItemAvailability.Availability9')"
                    ></span>
                    <span
                      class="mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-10 text-dark"
                      v-if="currentVariation.variation.availability.id == 10"
                      v-html="$translate('ohrensessel::ItemAvailability.Availability10')"
                    ></span>
                    <item-availability></item-availability>
                  </div>
                  <div class="fs-price text-right d-flex flex-column justify-content-end align-items-end">
                    <item-price :show-cross-price="isRecommendedPriceActive"></item-price>
                    <span class="vat small text-muted" v-html="$translate('ohrensessel::SingleItem.Vat')"></span>
                  </div>
                </div>

                <slot name="after-price"></slot>

                <div class="fs-button">
                  <div class="w-100">
                    <slot name="before-add-to-basket"></slot>
                  </div>

                  <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                    {{ $translate("Ceres::Template.singleItemSetInfo") }}
                  </div>
                  <div v-else class="col-12 my-3 px-0">
                    <add-to-basket
                      :variation-id="currentVariation.variation.id"
                      :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                      :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                      :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                      :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                      :maximum-quantity="
                        !!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null
                      "
                      :order-properties="
                        currentVariation.properties.filter(function(prop) {
                          return prop.property.isOderProperty;
                        })
                      "
                      :has-order-properties="currentVariation.hasOrderProperties"
                      :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                      :use-large-scale="false"
                      :show-quantity="true"
                      :item-url="currentVariation | itemURL"
                      :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                      :has-price="currentVariation | hasItemDefaultPrice"
                    >
                    </add-to-basket>
                  </div>

                  <div class="w-100">
                    <slot name="after-add-to-basket"></slot>
                  </div>
                </div>

                <!-- ./ITEM DETAIL -->

                <slot name="additional-content-after-add-to-basket"></slot>

                <slot name="additional-content-after-vat"></slot>
              </div>
              <!-- END BuyBox -->

              <div class="mb-5">
                <easycredit-widget webshop-id="1.de.12094.2" :amount="currentVariation.prices.default.price.value" extended="true" disable-flexprice="false" />
              </div>
              <!-- END SINGLEITEM_DETAILS -->

              <template v-if="currentVariation.variationProperties && currentVariation.variationProperties.length > 0">
                <template v-for="(variationPropertyGroups, index) in currentVariation.variationProperties" v-if="variationPropertyGroups.id === 8">
                  <p class="h4 font-weight-bold mb-3 px-3 px-md-0" v-html="$translate('ohrensessel::SingleItem.KeyFactsHeadline')"></p>
                  <ul class="list-unstyled m-0 p-0 px-3 px-md-0">
                    <template v-for="(variationProperty, index) in variationPropertyGroups.properties">
                      <li class="d-flex mb-3">
                        <i class="fa fa-check mr-3 mt-1"></i>
                        <span class="font-weight-bold" v-html="variationProperty.values.value"></span>
                      </li>
                    </template>
                  </ul>
                </template>
              </template>

              <template v-for="barcodes in currentVariation.barcodes" v-if="barcodes.name == 'EAN'">
                <p class="ml-3 ml-md-0 mb-0"><span>EAN: </span>{{ barcodes.code }}</p>
              </template>
              <template v-if="currentVariation.variation.number != ''">
                <p class="ml-3 ml-md-0 mb-0"><span>SKU: </span>{{ currentVariation.variation.number }}</p>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="single container-fluid bg-primary pt-3" id="itemnav">
        <div class="container-max p-0 position-relative">
          <ul class="single-nav list-unstyled d-flex justify-content-around m-2">
            <slot name="single-navigation"></slot>
          </ul>
        </div>
      </div>

      <div class="single container-max page-content addinfo mt-md-5 mb-3">
        <div class="row position-relative">
          <div class="col-12 col-lg-6 order-2 order-lg-1 d-flex flex-wrap align-self-start">
            <div class="order-1 order-lg-1 w-100">
              <!-- ITEM DESCRIPTION -->
              <p class="m-0" id="itemDesc"></p>
              <div class="item-description-container mb-45">
                <div class="item-description" :class="{ 'item-collapse': descriptionLength > 850 }">
                  <div ref="itemDescription" v-html="currentVariation.texts.description"></div>
                </div>

                <div id="descriptionToggle" v-if="descriptionLength > 850">
                  <button class="btn btn-link btn-inline-block text-primary text-decoration-none py-2 pl-0">
                    <span class="font-weight-bold show-more">mehr anzeigen <i class="fa fa-chevron-down float-none text-dark small"></i></span>
                    <span class="font-weight-bold show-less">weniger anzeigen <i class="fa fa-chevron-down float-none text-dark small"></i></span>
                  </button>
                </div>
              </div>
              <!-- ./ITEM DESCRIPTION -->

              <!-- Eigenschaft Montage -->
              <template>
                <div v-if="hasVariationProperties">
                  <div v-for="(variationPropertyGroups, index) in filteredVariationPropertyGroups" :key="index">
                    <p class="m-0" id="montage"></p>
                    <div
                      v-for="(variationProperty, subIndex) in variationPropertyGroups.properties"
                      :key="subIndex"
                      v-if="variationProperty.id === 239"
                      class="fs-montage bg-gray p-3 mb-45 border-radius"
                    >
                      <p class="h4 font-weight-bold mb-3">{{ $translate("ohrensessel::SingleItem.NavigationMontage") }}</p>
                      <div v-html="variationProperty.values.value"></div>
                    </div>
                  </div>
                </div>
              </template>

              <!-- Eigenschaft FAQ -->
              <template>
                <div v-if="hasVariationProperties">
                  <div v-for="(variationPropertyGroups, index) in filteredVariationPropertyGroups" :key="index">
                    <p class="m-0" id="faq"></p>
                    <div v-for="(variationProperty, subIndex) in variationPropertyGroups.properties" :key="subIndex" v-if="variationProperty.id === 240" class="fs-faq bg-gray p-3 mb-45 border-radius">
                      <p class="h4 font-weight-bold mb-3">{{ $translate("ohrensessel::SingleItem.NavigationFAQ") }}</p>
                      <div v-html="variationProperty.values.value"></div>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div class="order-2 order-lg-2 w-100">
              <div class="bg-gray p-3 mb-45 border-radius" id="techData">
                <p class="h4 font-weight-bold mb-3 mb-md-0">{{ $translate("Ceres::Template.singleItemTechnicalData") }}</p>
                <div class="mt-3" v-html="currentVariation.texts.technicalData"></div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-6 order-1 order-lg-2 px-0 px-lg-3">
            <div class="fs-xselling">
              <slot name="cross-selling-similar"></slot>
            </div>
            <div class="fs-xselling">
              <slot name="cross-selling-accessory"></slot>
            </div>

            <template>
              <div class="fs-manufacturer bg-gray p-3 mb-45 border-radius">
                <div v-if="hasVariationProperties">
                  <div v-for="(variationPropertyGroups, index) in filteredVariationPropertyGroups" :key="index">
                    <p class="m-0" id="manufacturer"></p>
                    <div v-for="(variationProperty, subIndex) in variationPropertyGroups.properties" :key="subIndex" v-if="variationProperty.id === 238" class="">
                      <p class="h4 font-weight-bold mb-3">{{ $translate("ohrensessel::SingleItem.NavigationManufacturer") }}</p>
                      <div v-html="variationProperty.values.value"></div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="my-4">
                    <p class="font-weight-bold">{{ $translate("Ceres::Template.singleItemManufacturer") }}</p>
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.name }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.legalName }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.street }}</span>
                      <span>{{ currentVariation.item.manufacturer.houseNo }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.postcode }}</span>
                      <span>{{ currentVariation.item.manufacturer.town }}</span>
                      <span v-if="currentVariation.item.manufacturer.countryObject">
                        {{ currentVariation.item.manufacturer.countryObject.name }}
                      </span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.email }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.url }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.phoneNumber }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.faxNumber }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.contactUrl }}</span>
                    </div>
                  </div>
                  <div class="my-4">
                    <p class="font-weight-bold">{{ $translate("Ceres::Template.singleItemEuResponsiblePerson") }}</p>
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleName }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleStreet }}</span>
                      <span>{{ currentVariation.item.manufacturer.responsibleHouseNo }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsiblePostCode }}</span>
                      <span>{{ currentVariation.item.manufacturer.responsibleTown }}</span>
                      <span v-if="currentVariation.item.manufacturer.responsibleCountryObject">
                        {{ currentVariation.item.manufacturer.responsibleCountryObject.name }}
                      </span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleEmail }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsiblePhoneNo }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleContactUrl }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <template>
              <div v-if="hasVariationProperties">
                <div v-for="(variationPropertyGroups, index) in filteredVariationPropertyGroups" :key="index">
                  <p class="m-0" id="range"></p>
                  <div v-for="(variationProperty, subIndex) in variationPropertyGroups.properties" :key="subIndex" v-if="variationProperty.id === 241" class="fs-range bg-gray p-3 mb-45 border-radius">
                    <p class="h4 font-weight-bold mb-3">{{ $translate("ohrensessel::SingleItem.NavigationRange") }}</p>
                    <div v-html="variationProperty.values.value"></div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <slot name="item-list-container"></slot>

        <slot name="feedback-container"></slot>
      </div>
    </slot>
  </div>
</template>

<script>
import { get } from "../../helper/get";
import { isNullOrUndefined } from "../../helper/utils";

export default {
  name: "single-item",

  props: {
    pleaseSelectOptionVariationId: {
      type: Number,
      default: 0,
    },
    initPleaseSelectOption: {
      type: Boolean,
      default: false,
    },
    showNetPrices: {
      type: Boolean,
      default: false,
    },
    isWishListEnabled: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: Number,
      required: true,
    },
    afterKey: Object,
  },

  jsonDataFields: ["itemData", "attributesData", "variations"],

  provide() {
    return {
      itemId: this.$props.itemId,
    };
  },
  computed: {
    savingMoneyPercent() {
      const hasPrice =
        !!this.currentVariation.prices.rrp &&
        ((this.currentVariation.prices.rrp.unitPrice.value - this.currentVariation.prices.default.price.value) / this.currentVariation.prices.rrp.unitPrice.value) * 100;
      return hasPrice;
    },
    hasVariationProperties() {
      return this.currentVariation.variationProperties && this.currentVariation.variationProperties.length > 0;
    },
    filteredVariationPropertyGroups() {
      return this.currentVariation.variationProperties.filter((group) => group.id === 34);
    },

    descriptionLength() {
      return this.currentVariation.texts.technicalData.length;
    },

    itemConfig() {
      return App.config.item.itemData;
    },

    isDescriptionTabActive() {
      return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.description.length;
    },
    isManufacturerTabShown() {
      return (
        this.currentVariation.item.manufacturer.url !== "" ||
        this.currentVariation.item.manufacturer.street !== "" ||
        this.currentVariation.item.manufacturer.houseNo !== "" ||
        this.currentVariation.item.manufacturer.postcode !== "" ||
        this.currentVariation.item.manufacturer.town !== "" ||
        this.currentVariation.item.manufacturer.countryId !== 0 ||
        this.currentVariation.item.manufacturer.phoneNumber !== "" ||
        this.currentVariation.item.manufacturer.faxNumber !== "" ||
        this.currentVariation.item.manufacturer.email !== "" ||
        this.currentVariation.item.manufacturer.legalName !== "" ||
        this.currentVariation.item.manufacturer.contactUrl !== "" ||
        this.currentVariation.item.manufacturer.name !== ""
      );
    },
    isEuResponsibleTabShown() {
      return (
        this.currentVariation.item.manufacturer.responsibleEmail !== "" ||
        this.currentVariation.item.manufacturer.responsibleHouseNo !== "" ||
        this.currentVariation.item.manufacturer.responsibleName !== "" ||
        this.currentVariation.item.manufacturer.responsiblePhoneNo !== "" ||
        this.currentVariation.item.manufacturer.responsiblePostCode !== "" ||
        this.currentVariation.item.manufacturer.responsibleStreet !== "" ||
        this.currentVariation.item.manufacturer.responsibleTown !== "" ||
        this.currentVariation.item.manufacturer.responsibleContactUrl !== "" ||
        this.currentVariation.item.manufacturer.responsibleCountry !== 0
      );
    },
    isRecommendedPriceActive() {
      return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
    },

    isShortDescriptionActive() {
      return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
    },

    hasShippingCostsCategoryId() {
      return App.config.global.shippingCostsCategoryId > 0;
    },

    isTechnicalDataTabActive() {
      return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.technicalData.length;
    },

    variationGroupedProperties() {
      return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
    },

    variationMissingProperties() {
      return this.$store.getters[`${this.itemId}/variationMissingProperties`];
    },

    currentVariation() {
      return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
    },

    isVariationSelected() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
    },

    attributes() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
    },

    units() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
    },

    isItemSet() {
      return this.$store.state.items.isItemSet;
    },
  },

  created() {
    this.$store.dispatch("initVariation", this.itemData);
    this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
        itemId: this.itemId,
        attributes: this.attributesData,
        variations: this.variations,
        initialVariationId: this.currentVariation.variation.id,
        isPleaseSelectOption: this.initPleaseSelectOption,
        afterKey: this.afterKey,
      });

      if (this.isItemSet) {
        this.$store.dispatch("initSetComponents", this.itemData);
      }
    });

    this.toggleDescription();

    // listen for variation change to hydrate all children lazy-hydrate components
    document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
  },

  methods: {
    toggleDescription() {
      $(".item-description-container #descriptionToggle span").on("click", (event) => {
        event.preventDefault();
        $(".item-description-container").toggleClass("show");
      });
    },

    getDataField(field) {
      return get(this.currentVariation, field);
    },

    getFilteredDataField(field, filter) {
      if (!isNullOrUndefined(this.$options.filters[filter])) {
        return this.$options.filters[filter](this.getDataField(field));
      }

      return this.getDataField(field);
    },

    // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
    hydrateChildren(nodes) {
      nodes.forEach((component) => {
        if (component.$options.name === "lazy-hydrate") {
          component.hydrate();
        } else if (component.$children.length) {
          this.hydrateChildren(component.$children);
        }
      });
    },
  },
};
</script>
